module.exports = __webpack_public_path__ + "img/campaigns-selected.47780b62.svg";